// extracted by mini-css-extract-plugin
module.exports = {"wrap":"checkbox_wrap__YJg3v"};